import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"

// Connects to data-controller="turbomodal"
export default class extends Controller {
  connect() {
    this.modal = new Modal(this.element, {
      backdrop: "static",
      keyboard: false
    })

    this.showModal = this.showModal.bind(this)

    if (document.body.classList.contains("modal-open")) {
      document.addEventListener("turbomodal:hidden", this.showModal, { once: true })
    } else {
      this.showModal()
    }
  }

  disconnect() {
    document.removeEventListener("turbomodal:hidden", this.showModal)

    if (!this.modal) return

    if (this.element.classList.contains("show")) {
      this.element.addEventListener("hidden.bs.modal", () => {
        this.modal.dispose()
        document.dispatchEvent(new CustomEvent("turbomodal:hidden"))
      }, { once: true })

      // A fast Turbo Frame replacement can disconnect the controller while
      // Bootstrap is still completing the show transition. In that case the
      // first hide call is ignored, so retry once the modal is fully shown.
      this.element.addEventListener("shown.bs.modal", () => this.modal.hide(), { once: true })
      this.modal.hide()
    } else {
      this.modal.dispose()
    }
  }

  showModal() {
    if (this.element.isConnected) {
      this.modal.show()
    }
  }

  submitEnd(e) {
    if (e.detail.success) {
      this.hideModal()
    }
    // console.log(e.detail.success)
  }

  hideModal() {
    this.modal.hide()
  }
}
